import { ApiClientError } from '../lib/api';
import { errorText, t } from '../lib/i18n';
import { Alert, Button } from './ui';

export function errorMessage(error: unknown): string {
  if (error instanceof ApiClientError) return errorText(error.body);
  return t('error.internal');
}

/** Field-level messages (path -> translated text) from a validation error. */
export function fieldErrors(error: unknown): Record<string, string> {
  if (error instanceof ApiClientError && error.fields) {
    return Object.fromEntries(Object.entries(error.fields).map(([k, v]) => [k, t(v, error.params)]));
  }
  return {};
}

export function ErrorPanel({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return (
    <div className="space-y-3 p-2">
      <Alert>{errorMessage(error)}</Alert>
      {onRetry ? <Button onClick={onRetry}>{t('common.retry')}</Button> : null}
    </div>
  );
}

/** Shows an error message if there is one. */
export function ErrorLine({ error }: { error: unknown }) {
  if (!error) return null;
  return <Alert>{errorMessage(error)}</Alert>;
}
